import { useDispatch } from 'store/hooks';
import { useMutation } from '@tanstack/react-query';

export const useRequestResetPassword = () => {
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: (email: string) =>
            dispatch.loginPage.requestResetPassword({
                email,
            }),
    });
};
